// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3Bq6w","large":"styles_large__1o8Qs"};